import RESTClient from 'web-app/api/clients/rest-client-famly-app';

export const updateDateOfBirth = (childId: string, dateOfBirth: string) => {
    const child = {birthday: dateOfBirth};
    return RESTClient.postAuthenticatedObservable(`v2/children/${childId}`, {
        ...child,
    });
};
